module.exports = __webpack_public_path__ + "static/img/Trent_Cotchin_mobile.e5818a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Trent_Cotchin_mobile.jpg
// module id = bC+e
// module chunks = 0